<template>
    <div class="wrapper ">
        Transport Application
    </div>
</template>

<script>
  export default {
    name: "TransportApplication"
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/TransportApplication.vue